var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.74854 12.8893L2.30003 15.3156C1.94485 15.4994 1.50728 15.3693 1.31147 15.0217V15.0217C1.25482 14.914 1.22426 14.7947 1.22223 14.6731V3.9223C1.22223 1.87191 2.62955 1.05176 4.65472 1.05176H9.41216C11.3755 1.05176 12.8447 1.81723 12.8447 3.7856V14.6731C12.8447 14.8671 12.7673 15.0531 12.6295 15.1903C12.4918 15.3274 12.3049 15.4044 12.1101 15.4044C11.9858 15.4025 11.8637 15.3721 11.7531 15.3156L7.27715 12.8893C7.11221 12.8006 6.91348 12.8006 6.74854 12.8893Z",
    fill: "white",
    stroke: "#F9B200",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/Bookmark.d550a12d604a9439d5da3a6736ff28f0.svg";
export { ForwardRef as ReactComponent };